module.exports = __webpack_public_path__ + "static/media/easi6_booking_zh-rCN.164cd385.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/easi6_booking_zh-rCN.md
// module id = 51
// module chunks = 0